export function businessEditionNav() {
    $(".smart-applications .navigation").on("click", "a", function() {
        if(!$(this).hasClass("active")){
            $(".smart-applications .navigation a").removeClass("active");
            $(this).addClass("active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/business-editions-navigation.js